/**
 * F 392 — the `inline-database` BlockNote block type.
 *
 * Two API facts measured in the installed 0.47.3 rather than assumed, because
 * both were wrong in the first attempt:
 *
 *  1. The React helper is `createReactBlockSpec` — there is NO exported
 *     `createReactBlock` in this version
 *     (node_modules/@blocknote/react/types/src/schema/ReactBlockSpec.d.ts:34).
 *
 *  2. `createReactBlockSpec(config, impl)` returns a FACTORY
 *     `(options?) => BlockSpec`, not a `BlockSpec`. `blockSpecs` on
 *     `BlockNoteSchema.create` wants the resolved `BlockSpec`, so the factory
 *     is invoked here once, at module scope.
 *     (Passing the factory straight in is a type error AND a runtime failure:
 *     the schema reads `spec.config`, which a function does not have.)
 *
 *  3. `render` receives `{ block, editor }`, NOT `blockProps`
 *     (ReactCustomBlockRenderProps, ReactBlockSpec.d.ts:5). `blockProps` is
 *     the inner helper's name (BlockContentWrapper.d.ts), which is why the
 *     first attempt typed `props.blockProps` and got TS2339.
 *
 * `blockSpecs` REPLACES rather than merges, so PageEditor spreads
 * `defaultBlockSpecs` and adds this alongside `codeBlock`. Forgetting the
 * spread would leave the editor with two block types and no paragraphs.
 */

import { createReactBlockSpec } from '@blocknote/react';
import { InlineDatabase } from './InlineDatabase';

const spec = createReactBlockSpec(
  {
    type: 'inlineDatabase',
    propSchema: {
      databaseId: { default: '' as string },
    },
    content: 'none',
  },
  {
    render: (props) => {
      const databaseId = (props.block?.props as { databaseId?: string })?.databaseId ?? '';
      return <InlineDatabase databaseId={databaseId} />;
    },
    // Required by ReactCustomBlockImplementation. Without it, copying or
    // pasting the block out of the editor throws on the paste path.
    toExternalHTML: () => null,
  },
);

/** The resolved BlockSpec, for `BlockNoteSchema.create({ blockSpecs })`. */
export const inlineDatabaseBlock = spec();

export default inlineDatabaseBlock;